import Vue from "vue";
import Router from "vue-router";
import routes from "./maps";

Vue.use(Router);

// 获取原型对象上的push函数
const originalPush = Router.prototype.push;
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history",
  base: "/lry",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有savedPosition（浏览器前进后退），使用保存的位置
    if (savedPosition) {
      return savedPosition;
    }

    // 如果是帮助页面的锚点跳转，不自动滚动到顶部
    if (to.name === "HelpQuestion" && to.params && to.params.anchor) {
      console.log("路由检测到锚点跳转，禁用自动滚动:", to.params.anchor);
      return false; // 不自动滚动，让组件自己处理
    }

    // 其他情况滚动到顶部
    return { x: 0, y: 0 };
  },
});
